import React from 'react';
import clsx from "clsx";
import numeral from 'numeral';
export default class RatePresenterGuestTypes extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'guest_types',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="guest_types">
        <div className="row">
          <div className="col-md-12">
            { this.renderGuestTypes() }
          </div>
        </div>
      </div>  
    )
  }

  renderGuestTypes() {
    var self = this
    var guest_types = this.props.guest_types.map(function (guest_type) {
      var rate_guest_type = self.getRateGuestType(guest_type)
      return (
        <div key={guest_type.id}>
          <div className="col-md-3 name-wrapper">
            <div className="form-group">
              <label>{I18n.t('guest_type')}</label>
              <div>{guest_type.name} ({self.renderAgeRange(guest_type)})</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('guests_included')}</label>
              {
                rate_guest_type 
                  ? <div>{rate_guest_type.guests_included || 0}</div> 
                  : 0
              }
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('amount_per_additional_guest')}</label>
              {
                rate_guest_type 
                  ? <div>
                      ${numeral(rate_guest_type.additional_guest_price_amount / 100).format(self.props.numberFormat)}
                    </div> 
                  : ''
              }
            </div>
          </div>
          <div className="col-md-3">
              <label>{I18n.t('frequency')}</label>
              {
                rate_guest_type 
                  ? <div>
                      {I18n.t(rate_guest_type.frequency || 'one_time')}
                    </div> 
                  : <div>{I18n.t('one_time')}</div>
              }
          </div>
        </div>
      )
    })

    return (
      <div className="guest-types-form">
        {guest_types}
      </div>
    )
  }

  renderAgeRange(guest_type) {
    if (guest_type.maximum_age == null || typeof guest_type.maximum_age == 'undefined') {
      return (
        <span>{guest_type.minimum_age}+</span>
      )
    } else {
      return (
        <span>{guest_type.minimum_age} &ndash; {guest_type.maximum_age}</span>
      )
    }
  }

  renderErrors() {
    var errors = RateBuilderErrors.guest_types(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  getRateGuestType(guest_type) {
    if (this.props.rate_guest_types && this.props.rate_guest_types.length) {
      for (var i = 0, ilen = this.props.rate_guest_types.length; i < ilen; i++) {
        if (this.props.rate_guest_types[i].guest_type_id == guest_type.id) {
          return this.props.rate_guest_types[i];
        }
      }
    }
    return null
  }
}